document.addEventListener('DOMContentLoaded', () => {
  let form = document.getElementById('customerHighlights');
  let submitBtn = document.querySelector('#customerHighlights input[type=submit]');

  if(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      submitBtn.setAttribute('disabled', '');
      submitBtn.classList.remove('c-btn--primary');

      document.querySelector('#custom-form__modal').style.display = 'flex';
  
      let fd = new FormData(this);
  
      let fName = fd.get('firstName').trim();
      let lName = fd.get('lastName').trim();
  
      let username = `${fName} ${lName}`.toLowerCase().replace(/\s/gi, '_');
  
      let company = fd.get('company');
      let website = fd.get('website');
      let email = fd.get('email');
      let phone = fd.get('phone');
      let details = fd.get('projectDetails');
      let photoDetails = fd.get('photoDetails');
      let additionalDetails = fd.get('additionalDetails');
      
      let files = fd.getAll('files');
  
      const folderCreateUrl = 'https://script.google.com/macros/s/AKfycbxp4rRGxYY0PMkfEnZSQUF68UkPKwJFJFPvaOFp8uBeDVAEj3SwsCNEMiyaI9HrFbXNhg/exec';
      const root = "1J7ZEXtNBDNg9_b5ime7VTn-VhiMdSCYn" // <--- Please set the id of the Drive folder
  
  
      // PS: The file upload web app, spreadsheet web app, and the google drive should be all from the same google account

      // folderCreateUrl script @Create Folder in Drive on kulgrilles.info@gmail.com
      // mailUrl script @sendMail on kulgrilles.info@gmail.com
      // uploadUrl script @File Upload Manager on kulgrilles.info@gmail.com
      // sheetUrl script @Write in Google Sheet on kulgrilles.info@gmail.com
  
      let submitForm = fetch(folderCreateUrl, {method: "POST", body: JSON.stringify({driveId: root, username: username})})
      .then(res => {

        const timeStampOptions = {year: 'numeric', month: 'short', day: 'numeric', hour12: true, hour: 'numeric', minute: '2-digit', timezone: 'America/Winnipeg', timeZoneName: 'short'};
        const timeStamp = Intl.DateTimeFormat('en-US', timeStampOptions).format(new Date());
        
        let to = 'support@kulgrilles.com';
        let cc = 'ishand@kulgrilles.com,cindyb@kulgrilles.com,sales@kulgrilles.com';
        let subject = 'Customer Highlights New Entry';
        let htmlBody = `
        <div>
          <h1>Customer Highlights New Entry</h1>
          <br/>
          <p>First Name: ${fName}</p>
          <p>Last Name: ${lName}</p>
          <p>Email: <a href="mailto:${email}">${email}</a></p>
          <p>Phone Number: ${phone}</p>
          <p>Company: ${company}</p>
          <p>Website: <a href="${website}" target="_blank">${website}</a></p>
          <p>Project Details: ${details}</p>
          <p>Photo Details: ${photoDetails}</p>
          ${additionalDetails ? `<p>Photographer Details: ${additionalDetails}</p>` : ''}
          <p>Folder Name: ${username}</p>
          <p>Customer clicked checkbox to accept terms:  “By sending this content, I confirm that our firm has the rights to these photos being submitted and we agree to allow kul grilles to use this content in marketing communications” [Clicked yes @ ${timeStamp}]</p>
        </div>
        `;

        let mailUrl = 'https://script.google.com/macros/s/AKfycbxtGs09MgImWMu1EHz_HQIXT9jmzeV478SEKhSxHGe5OywN3g0KP2mXYeDCJvnApRtE/exec';
        let mailPayload = {
          to: to,
          cc: cc,
          subject: subject,
          body: htmlBody
        };
        fetch(mailUrl, {method: "POST", body: JSON.stringify(mailPayload)});
        
        return res.json();
      })
      .then(a => {
        let r = Promise.all([...files].map((file, i) => {
          return new Promise(r => {
            let fr = new FileReader();
        
            fr.readAsArrayBuffer(file);
            fr.onload = e => {
              const data = e.target.result;
        
              const uploadUrl = "https://script.google.com/macros/s/AKfycbwoTW6uKFItEtj7EtuzcmaZipZGHtffgxQu_njXwYsa8xa8U31ijLBaqO8aLNBGVpJh-w/exec" // <--- Please set the URL of Google Web App
        
              let fileJSON = {
                'fileData': [...new Int8Array(data)],
                'mimeType': file.type,
                'fileName': file.name
              };
        
              let uploadPayload = {
                'username': username,
                'file': fileJSON,
                'driveId': root,
              };
        
              fetch(uploadUrl, {method: "POST", body: JSON.stringify(uploadPayload)})
              .then(res => r(res.json()));
            };
          });
        }))
        .then(data => {
          if(a.existing === false) {
            let sheetId = '1EaKa3DQIJYDwTYSoU25XZKR5lUdtCab9RNTLfYke3jE';
            let sheet = 'Sheet1';
            let sheetUrl = 'https://script.google.com/macros/s/AKfycbwBbH1PRAg59y05gpvR03ZeB-wmT2g0sYZtMsuBW_lzeWkFssKNupCKvIGnUnQfeLSa3A/exec';
  
            let sheetData = [fName, lName, email, phone, company, website, details, photoDetails, additionalDetails, username, data[0].folderUrl]
            let sheetPayload = {
              sheetId: sheetId,
              sheetName: sheet,
              sheetData: [sheetData]
            };
  
            fetch(sheetUrl, {method: "POST", body: JSON.stringify(sheetPayload)})
            .then(res => res.json())
            .then(ef => console.log('sent'));
          };


          document.querySelector('#custom-form__modal').style.display = 'none';

          form.reset();

          submitBtn.removeAttribute('disabled');

          submitBtn.classList.add('c-btn--primary');

          document.querySelector('#submit_success p').style.display = "block";
          
          setTimeout(() => {
            document.querySelector('#submit_success p').style.display = "none";
          },4000);

        });
      })
      .catch(err => console.log(err));
    });

    const displayAdditionalInfoBox = () => {
      const selectorElm = document.getElementById('additionalInfoSelectors');
      const labelElm = document.getElementById('additionalInfoLabels');
      const selectElm = document.querySelectorAll('.custom-form__dropdown');
      const additionalInfoContainer = document.getElementById('additionalInfoBox');
  
      let selectors = null;
      let labels = null;
  
      if(selectorElm && selectorElm.value !== '') {
        selectors = selectorElm.value.split(', ');
      }
  
      if(labelElm && labelElm.value !== '') {
        labels = labelElm.value.split(', ');
      }
  
      selectElm.forEach(elm => {
        elm.addEventListener('change', function() {
          // while(additionalInfoContainer) {
          //   additionalInfoContainer.removeChild(additionalInfoContainer.firstChild);
          // };

          additionalInfoContainer.innerHTML = '';
  
          if(selectors) {
            selectors.forEach((selector, index) => {
              if(elm.value === selector) {
                let additionalInfoLabel = null;
                if(labels[index] && labels[index] !== '') {
                  additionalInfoLabel = document.createElement('label');
                  additionalInfoLabel.setAttribute('for', `custom-form__${labels[index].trim().replace(' ', '')}`);
                  additionalInfoLabel.innerText = labels[index];
                  additionalInfoContainer.appendChild(additionalInfoLabel);
                };
  
                let additionalInfoInput = document.createElement('input');
                additionalInfoInput.setAttribute('type', 'text');
                additionalInfoInput.setAttribute('name', 'additionalDetails');
                // additionalInfoInput.setAttribute('placeholder', 'Please add additional information here');
                additionalInfoInput.setAttribute('id', `custom-form__${labels[index].trim().replace(' ', '')}`);
  
                additionalInfoContainer.appendChild(additionalInfoInput);
                return;
              }
            })
          }
        })
      });
    };
    
    displayAdditionalInfoBox();
  };
});